import React, { lazy, Suspense, useEffect, useMemo, useRef, useState } from "react";
import { getAllBoxes, getBoxById } from "./services/BoxService";
// Temporarily disabled: customer accounts.
// import {
//   confirmPasswordReset,
//   completeExternalLogin,
//   consumeExternalLoginReturnHash,
//   getGoogleLoginStatus,
//   loginAccount,
//   registerAccount,
//   requestPasswordReset,
//   updateAccount
// } from "./services/accountService";
// Temporarily disabled: import AccountModal from "./components/AccountModal";
import HomePage from "./components/HomePage";
// Temporarily disabled: import { persistStoredAccount, readStoredAccount } from "./app/accountStorage";
import {
  createBoxRouteSlug,
  createProductRoute,
  createProductRouteSlug,
// Temporarily disabled:   getExternalLoginTicket,
  getHash,
  getHomeSectionId,
  getHomeSectionRoute,
  getProductRouteSection,
// Temporarily disabled:   getPasswordResetParams,
  getSelectedBoxId,
  isAdminHash,
  privacyNoticeRoute,
  termsRoute,
  rentalAgreementRoute,
  resetPasswordRoutePrefix,
  toRoutePath
} from "./app/routes";
import "./App.css";

const AdminPage = lazy(() => import("./components/AdminPage"));
const BoxBookingPage = lazy(() => import("./components/BoxBookingPage"));
const PrivacyNoticePage = lazy(() => import("./components/PrivacyNoticePage"));
const RentalAgreementPage = lazy(() => import("./components/RentalAgreementPage"));
const TermsPage = lazy(() => import("./components/TermsPage"));

const translations = {
  hu: {
    nav: {
      products: "Tetőboxok",
      roofBoxes: "Tetőboxok",
      roofRacks: "Kerékpártartók",
      skiSnowboard: "Sí és Snowboard",
      guide: "Tudnivalók",
      prices: "Árak",
      faq: "GYIK",
      contact: "Kapcsolat",
      admin: "Admin",
      openMenu: "Menü megnyitása",
      closeMenu: "Menü bezárása"
    },
    footer: {
      privacy: "Adatkezelési tájékoztató",
      terms: "ÁSZF"
    },
    languageLabel: "Nyelv",
    account: {
      guestLabel: "Bejelentkezés",
      menuLabel: "Fiók",
      loggedInPrefix: "Szia,",
      loginTitle: "Bejelentkezés",
      registerTitle: "Regisztráció",
      editTitle: "Fiók adatai",
      subtitleLogin: "Lépj be, és a foglalási adatok automatikusan kitöltődnek.", //ez mi?
      subtitleRegister: "Ha regisztrálsz, később kedvezményeket kaphatsz.",
      subtitleEdit: "Itt frissítheted az adataid.",
      switchToLogin: "Van már fiókom",
      switchToRegister: "Új fiók",
      saveChanges: "Mentés",
      logout: "Kijelentkezés",
      openEdit: "Adatok szerkesztése",
      close: "Bezárás",
      name: "Teljes név",
      email: "E-mail cím",
      phone: "Telefonszám",
      password: "Jelszó",
      confirmPassword: "Új jelszó újra",
      resetCode: "Visszaállítási token",
      namePlaceholder: "Pl. Kiss Janos",
      emailPlaceholder: "pelda@email.hu",
      phonePlaceholder: "+36 30 123 4567",
      passwordPlaceholder: "Legalább 6 karakter",
      confirmPasswordPlaceholder: "Írd be újra az új jelszót",
      resetCodePlaceholder: "Automatikusan kitöltve a linkből", //ez mi?
      submitLogin: "Bejelentkezés",
      submitRegister: "Fiók létrehozása",
      submitResetRequest: "Jelszó visszaállítása", // ez mi?
      submitResetConfirm: "Új jelszó mentése",
      continueWithGoogle: "Folytatás Google-lel",
      externalLoginDivider: "vagy",
      loading: "Folyamatban...",
      loginSuccess: "Sikeres bejelentkezés.",
      registerSuccess: "Sikeres fióklétrehozás.",
      updateSuccess: "A fiók adatai frissültek.",
      registerCelebration: "Sikeres regisztráció",
      registerCelebrationText: "A fiókod elkészült, most már foglalhatsz is.",
      completeProfilePrompt: "A Google bejelentkezés sikerült. A fiók véglegesítéséhez add meg a telefonszámod.",
      profileCompleteSuccess: "A fiók adatai megfelelnek.",
      forgotPassword: "Elfelejtett jelszó?",
      resetRequestTitle: "Jelszó visszaállítása",
      resetConfirmTitle: "Új jelszó beállítása",
      subtitleResetRequest: "Add meg az email címedet, és küldünk egy egyszer használható jelszó visszaállítási linket.",
      subtitleResetConfirm: "A visszaállítási link megnyitása után itt adhatod meg az új jelszavad.",
      resetRequestSuccess: "Elküldtük a visszaállítási linket az e-mail címre.",
      resetConfirmSuccess: "A jelszó sikeresen megváltozott. Most már bejelentkezhetsz.",
      backToLogin: "Vissza a belépéshez",
      validationError: "Töltsd ki helyesen a kötelező mezőket.",
      resetRequestValidationError: "Adj meg egy érvényes email címet.",
      resetConfirmValidationError: "Add meg az emailedet, a visszaigazoló kódot, és két egyező új jelszót.",
      passwordError: "Adj meg legalább 6 karakteres jelszót.",
      confirmPasswordError: "Írd be újra az új jelszót.",
      passwordMismatchError: "A két jelszó nem egyezik.",
      emailError: "Adj meg egy érvényes e-mail címet.",
      phoneError: "Adj meg egy érvényes telefonszámot.",
      nameError: "Adj meg legalább 2 karakterből álló nevet.",
      resetCodeError: "Hiányzik a visszaállítási kód a linkből."
    },
    brand: "Pakold Fel",
    hero: {
      eyebrow: "Pakold Fel",
      titleLines: ["Tetőbox bérlés", "Kerékpártartó bérlés", "Hólánc bérlés"],
      text: "",
      imageAlt: "Autó tetőboxszal hegyvidéki környezetben"
    },
    products: {
      kicker: "Tetőboxok",
      title: "",
      scrollPrevious: "Görgetés balra",
      scrollNext: "Görgetés jobbra"
    },
    accessories: {
      kicker: "Kerékpártartók",
      title: ""
    },
    skiSnowboard: {
      kicker: "Sí és Snowboard",
      title: ""
    },
    guide: { // ez van még használva?
      kicker: "Miért minket válassz",
      title: "Minden fontos tudnivaló egy helyen",
      subtitle: "Röviden összeraktuk a legfontosabb infókat, hogy gyorsan átlásd a bérlés menetét és a hozzá tartozó feltételeket.",
      steps: [
        {
          title: "1. Ingyenes felszerelés",
          text: "A felszerelést mi végezzük, ezért a bérléshez nem kell külön szerelési díjjal számolnod."
        },
        {
          title: "2. Megfelelő tetősín minden autótípushoz",
          text: "Ha az autódon nincs saját rendszer, segítünk a megfelelő tetősín kiválasztásában és biztosítunk kompatibilis megoldást."
        },
        {
          title: "3. Átlátható fizetés és kaució",
          text: "A napi bérleti díj mellett előre látod a termékhez tartozó kauciót és a választható fizetési módokat is."
        }
      ]
    },
    prices: {
      kicker: "Árak",
      title: "",
      wingBarKitNote: "Első bérlés esetén 10.000 Forint kerül felszámolásra, ha autóspecifikus rögzítő is szükséges a felszereléshez.",
      columns: {
        product: "Termék",
        volume: "Térfogat",
        dailyPrice: "Napi ár",
        deposit: "Kaució",
        recommendation: "Ajánlott"
      }
    },
    faq: {
      kicker: "GYIK",
      title: "",
      items: [
        {
          title: "Mennyibe kerül a felszerelés?",
          text: "A felszerelést mi végezzük, ezért nem számolunk fel külön felszerelési díjat."
        },
        {
          title: "Van megfelelő tetősín minden autóhoz?",
          text: "Igen, segítünk megtalálni a megfelelő megoldást, és olyan tetősínt biztosítunk, ami az adott autótípushoz illik."
        },
        {
          title: "Hogyan láthatom előre az árakat és a kauciót?",
          text: "A napi bérleti díj mellett a foglalás során előre látod a termékhez tartozó kauciót is."
        },
        {
          title: "Hogyan számoljuk a házhozszállítást?",
          text: "A házhozszállítás díját mindig egy alapdíj és a megtett kilométerek alapján számoljuk. A pontos összeget a foglalás során, a cím megadása után látod. A feltüntetett ár tartalmazza az átadás és az átvételi kiszállási díját is."
        },
        {
          title: "Mikor érdemes foglalni a tetőboxot?",
          text: "Két héttel a tervezett indulás előtt érdemes foglalni, hogy a bérelt eszköz átadása egy kényelmes időpontban történhessen."
        },
        {
          title: "Mit érdemes hozni az átvételhez?",
          text: "Elég, ha az autó, valamint a személyi igazolvány és lakcímkártya nálad vannak. A többit mi biztosítjuk."
        }
      ]
    },
    landing: {
      eyebrow: "Budapesti tetőbox bérlés",
      title: "Tetőbox bérlés Budapesten egyszerűen",
      lead:
        "Ha kifejezetten budapesti tetőbox bérlésre keresel megoldást, itt gyorsan látod az árakat, a kauciót, az átvételt és a foglalási lehetőséget.",
      cards: [
        {
          title: "Átlátható árak",
          text: "Rögtön látod, mennyibe kerül a kiválasztott tetőbox vagy tetőcsomagtartó, plusz a hozzá tartozó kaució."
        },
        {
          title: "Budapesti átvétel",
          text: "Az átvétel előre egyeztetett időpontban, könnyen megközelíthető budapesti helyszínen történik."
        },
        {
          title: "Segítünk választani",
          text: "Ha nem vagy biztos benne, melyik box vagy tetősín illik az autódhoz, segítünk kiválasztani a megfelelőt."
        }
      ],
      ctaBoxes: "Tetőboxok megtekintése",
      ctaContact: "Kapcsolat",
      backHome: "Vissza a főoldalra",
      note:
        "A foglalás gyors, az árak és a kaució előre látható, így könnyen össze tudod hasonlítani a lehetőségeket."
    },
    contact: {
      kicker: "Kapcsolat",
      title: "",
      phone: "Telefon",
      phoneValue: "+36 30 833 9512",
      email: "E-mail",
      emailValue: "info@pakoldfel.hu",
      pickup: "Átvétel",
      pickupValue: "1095 Budapest, Máriássy utca 6A (P6-os garázskapu)"
    },
    admin: {
      kicker: "Foglalási admin",
      title: "Beérkező és aktív foglalások",
      subtitle: "Itt láthatod, mikor jönnek a felszerelésért, meddig tart a bérlés, és hogy kértek-e WingBart is.",
      backButton: "Vissza a weboldalra",
      loading: "Foglalások betöltése...",
      loadError: "A foglaláslista most nem érhető el.",
      yes: "Igen",
      no: "Nem",
      currency: "Ft",
      rentalNumberValue: "{count}. foglalás",
      guestRentalValue: "Vendég",
      columns: {
        product: "Termék",
        customer: "Ügyfél",
        rentalNumber: "Bérlői szám",
        contact: "Kapcsolat",
        vehicle: "Autó",
        roofMount: "Rögzítési pont",
        pickup: "Átvétel",
        from: "Kezdőnap",
        to: "Zárónap",
        wingBar: "WingBar",
        delivery: "Házhozszállítás",
        paymentMethod: "Fizetés",
        deposit: "Kaució",
        pickupSuggestion: "Javaslat",
        deliveryAddress: "Cím",
        total: "Összesen"
      },
      pricing: {
        kicker: "Árak",
        title: "A tetőboxok és tetőcsomagtartók árainak módosítása",
        text: "Itt tudod frissíteni az egyes termékek napi díját és a hozzájuk tartozó kauciót.",
        railLabel: "Tetőcsomagtartó",
        boxLabel: "Tetőbox",
        bikeLabel: "Kerékpártartó",
        winterLabel: "Sí és Snowboard",
        dailyPrice: "Napi ár (Ft)",
        deposit: "Kaució (Ft)",
        submit: "Ár mentése",
        saving: "Mentés...",
        success: "Az árak elmentve.",
        error: "Most nem sikerült elmenteni az árakat."
      },
      dashboard: {
        activeRentals: "Aktív bérlések",
        upcomingPickups: "Mai és holnapi átvételek",
        wingBarRentals: "WingBarral kért foglalások",
        pickupSuggestions: "Időjavaslatos foglalások"
      },
      filters: {
        all: "Összes",
        today: "Mai átvételek",
        delivery: "Házhozszállítás",
        wingBar: "WingBar"
      },
      schedule: {
        kicker: "Átvételi idősávok",
        title: "Napi szerelési idők testreszabása",
        text: "Adj meg külön idősávot egy adott napra, ha a megszokott 18:00-21:00 közötti ablakot módosítani szeretnéd.",
        date: "Dátum",
        start: "Kezdés",
        end: "Vége",
        hour: "Óra",
        minute: "Perc",
        interval: "Intervallum (perc)",
        submit: "Idősáv mentése",
        saving: "Mentés...",
        success: "Az egyedi idősáv elmentve.",
        error: "Most nem sikerült elmenteni az egyedi idősávot.",
        empty: "Még nincs felülírt idősáv."
      },
      delivery: {
        kicker: "Házhozszállítás",
        title: "Házhozszállítási díjak beállítása",
        text: "Itt adhatod meg, honnan számoljuk a távolságot, mekkora az alapdíj, és mennyi a kilométerenkénti díj.",
        enabled: "Házhozszállítás engedélyezése",
        originAddress: "Kiindulási cím",
        freeDeliveryRadius: "Ingyenes körzet sugara (km)",
        originsHelp: "A megadott légvonalbeli sugáron belül, a kör határát is beleértve, 0 Ft a házhozszállítás. A 0 km kikapcsolja az ingyenes körzetet. A körzeteken kívül a legközelebbi pontból számoljuk a díjat.",
        addOrigin: "Új kiindulási pont",
        removeOrigin: "Pont eltávolítása",
        originAddressPlaceholder: "Például: Budapest, XI. kerület, Etele út 10.",
        baseFee: "Alapdíj (Ft)",
        pricePerKilometer: "Kilométerdíj (Ft / km)",
        submit: "Házhozszállítás mentése",
        saving: "Mentés...",
        success: "A házhozszállítási beállítások elmentve.",
        error: "Most nem sikerült elmenteni a házhozszállítási beállításokat."
      },
      sections: {
        activeKicker: "Következő feladatok",
        activeTitle: "Közelgő és függőben lévő bérlések",
        activeEmpty: "Jelenleg nincs közelgő vagy aktív bérlés.",
        previousKicker: "Archívum",
        previousTitle: "Korábbi bérlések",
        previousEmpty: "Még nincs lezárt bérlés az archívumban."
      },
      emptyTitle: "Még nincs rögzített foglalás",
      emptyText: "Amint valaki lefoglal egy tetőboxot vagy tetősínt, itt fog megjelenni a listában.",
      auth: {
        kicker: "Admin belépés",
        title: "Jelentkezz be az admin felülethez",
        text: "Add meg a konfigurált admin felhasználónevet és jelszót.",
        checking: "Admin session ellenőrzése...",
        loadError: "Az admin felület most nem érhető el.",
        sessionExpired: "A munkamenet lejárt, jelentkezz be újra.",
        username: "Felhasználónév",
        usernamePlaceholder: "pl. admin",
        password: "Jelszó",
        passwordPlaceholder: "Add meg a jelszót",
        submit: "Bejelentkezés",
        submitting: "Bejelentkezés...",
        loginError: "Sikertelen admin belépés.",
        logout: "Kijelentkezés",
        loggedInAs: "Bejelentkezve mint: {username}"
      }
    },
    boxCard: {
      available: "Elérhető most",
      unavailable: "Jelenleg nem elérhető",
      details: "Részletek és foglalás",
      liters: "liter",
      roofRailFact: "Tetősín szett",
      skiRackCapacity: "6 síléc",
      bikeMountLocations: {
        "bike-towbar": "Vonóhorogra",
        "bike-roof": "Tetőre",
        "bike-rear": "Csomagtartóra"
      },
      stockLabel: "db készlet",
      remainingLabel: "szabad",
      pricePerDay: "Ft / nap",
      depositLabel: "Kaució",
      currency: "Ft"
    },
    booking: {
      kicker: "Foglalás",
      title: "Foglalási adatok",
      formTitle: "Foglalás",
      productFeaturesTitle: "Főbb jellemzők",
      contactSectionTitle: "Kapcsolat",
      rentalSectionTitle: "Bérlési időszak",
      extraSectionTitle: "Megjegyzés",
      summaryTitle: "Foglalási összegzés",
      summaryProduct: "Választott termék",
      summaryDates: "Bérlési időszak",
      summaryDatesEmpty: "Még nincs kijelölve",
      summaryVehicle: "Autó",
      summaryVehicleEmpty: "Még nincs megadva",
      summaryRoofMount: "Rögzítési pont",
      summaryRoofMountEmpty: "Még nincs kiválasztva",
      summaryPickup: "Átvételi idősáv",
      summaryPickupEmpty: "Még nincs kiválasztva",
      summaryPickupSuggested: "Külön egyeztetéssel",
      summaryWingBar: "Tetősín kiegészítő",
      summaryDeposit: "Kaució",
      summaryPaymentMethod: "Fizetési mód",
      summaryPaymentMethodEmpty: "Még nincs kiválasztva",
      summaryDelivery: "Házhozszállítás",
      summaryDeliveryAddress: "Fel- és levételi cím",
      summaryDeliveryAddressEmpty: "Még nincs megadva",
      summaryDeliveryFee: "Házhozszállítási díj",
      summaryDeliveryFeeEmpty: "Add meg a címet a számításhoz",
      summaryIncluded: "Igen, kérem",
      summaryNotIncluded: "Nem szükséges",
      summarySuggestion: "Külön időpontjavaslat",
      summaryComment: "Megjegyzés",
      summaryCommentEmpty: "Nincs megadva",
      summaryDays: "Napok száma",
      guestMode: "Vendég",
      loginMode: "Bejelentkezés",
      loginModeHelper: "Jelentkezz be vagy hozz létre egy fiókot, és a rendszer automatikusan kitölti az adataidat.",
      customerName: "Teljes név",
      customerEmail: "E-mail cím",
      customerPhone: "Telefonszám",
      customerNamePlaceholder: "Pl. Kiss Péter",
      customerEmailPlaceholder: "pelda@email.hu",
      customerPhonePlaceholder: "+36 30 833 9512",
      bookingCommentLabel: "Megjegyzés",
      bookingCommentPlaceholder: "Például: külön kérés, fontos információ vagy bármi, amit érdemes egyeztetni.",
      includeWingBarLabel: "Tetőcsomagtartóval",
      homeDeliveryLabel: "Házhozszállítást kérek ugyanarra a címre a fel- és levételhez is.",
      deliveryAddressLabel: "Fel- és levételi cím",
      deliveryAddressPlaceholder: "Például: Budapest, IX. kerület, Máriássy utca 6.",
      deliveryAddressError: "Adj meg egy részletes címet a házhozszállításhoz.",
      deliveryAddressTooShort: "A cím még túl rövid a díjszámításhoz.",
      deliveryCalculationError: "Most nem sikerült kiszámolni a házhozszállítási díjat.",
      deliveryCalculationMissing: "A házhozszállítási díj kiszámítása még nem készült el.",
      deliveryCalculating: "Házhozszállítási díj számítása...",
      deliveryMapTitle: "Cím ellenőrzése térképen",
      deliveryMapShow: "Cím ellenőrzése térképen",
      deliveryMapHide: "Térkép elrejtése",
      deliveryMapOpen: "Megnyitás nagy térképen",
      paymentSectionTitle: "Fizetés",
      paymentMethodError: "Válassz egy fizetési módot.",
      paymentOptions: [
        {
          value: "cash-on-pickup",
          label: "Személyesen készpénzzel"
        },
        {
          value: "transfer-on-pickup",
          label: "Személyesen utalással"
        }
      ],
      roofMountTypes: [
        {
          value: "raised-rails",
          label: "Tetőkorlátos"
        },
        {
          value: "naked-roof",
          label: "Normál, rögzítési pont nélküli"
        },
        {
          value: "flush-rails",
          label: "Integrált tetősínes"
        },
        {
          value: "fixed-points",
          label: "Fixpontos"
        }
      ],
      roofMountTypeLabel: "Rögzítési pont típusa",
      roofMountTypeError: "Válassz egy rögzítési pont típust.",
      vehicleBrand: "Autó márkája",
      vehicleModel: "Autó típusa",
      vehicleYear: "Évjárat",
      vehicleBrandPlaceholder: "Például: Volkswagen",
      vehicleModelPlaceholder: "Például: Passat",
      vehicleYearPlaceholder: "Például: 2020",
      snowChainSectionTitle: "Hólánc adatok",
      snowChainVehicleDetails: "Autó pontos típusa",
      snowChainVehicleDetailsPlaceholder: "Például: Volkswagen Passat, 2020",
      snowChainVehicleDetailsError: "Add meg az autó pontos típusát.",
      snowChainWheelSize: "Kerékméret",
      snowChainWheelSizePlaceholder: "Például: 225/50 R17",
      snowChainWheelSizeError: "Add meg a kerék méretét.",
      vehicleBrandError: "Adj meg egy valódi márkanevet.",
      vehicleModelError: "Adj meg egy valódi típust.",
      vehicleYearError: "Adj meg egy érvényes évjáratot.",
      vehicleFieldsError: "Töltsd ki az autó adatait is.",
      pickupNoteError: "",
      missingDates: "Válaszd ki a bérlés kezdő- és zárónapját.",
      missingPickupSlot: "Válassz egy szabad felszerelési idősávot is.",
      loginBeforeBookingError: "Jelentkezz be mielőtt foglalnál.",
      bookingError: "Nem sikerült a foglalás.",
      bookingSuccess: "A foglalást sikeresen rögzítettük.",
      successTitle: "Sikeres foglalás",
      successBannerText: "A foglalásodat rögzítettük. Hamarosan felvesszük a kapcsolatot az átadás és az átvétel pontos időpontjával.",
      consentSectionTitle: "Elfogadás",
      termsConsentLabel: "Elfogadom az",
      privacyConsentLabel: "Elfogadom az",
      termsLinkLabel: "ÁSZF-et",
      privacyLinkLabel: "Adatvédelmi nyilatkozatot",
      consentError: "A foglalás véglegesítéséhez fogadd el az ÁSZF-et és az Adatvédelmi nyilatkozatot.",
      submit: "Foglalás véglegesítése",
      submitting: "Feldolgozás...",
      totalPrice: "Végösszeg",
      microHelperTitle: "Rövid segítség a foglaláshoz",
      microHelperText: "Vendégként is végigmehetsz a folyamaton, de fiókkal a következő foglalás már gyorsabb lesz.",
      helperSteps: [
        {
          title: "1. Válassz időszakot",
          text: "Jelöld ki a naptárban, hogy mettől meddig van szükséged a termékre."
        },
        {
          title: "2. Ellenőrizd az elérhetőséget",
          text: "A sötétebb napok foglaltak, a kijelölt időszakodat külön színnel emeljük ki."
        },
        {
          title: "3. Rögzítsd az átvételt",
          text: "Válassz szabad szerelési sávot, vagy külddel javaslatod nekünk."
        }
      ],
      suggestionTitle: "Más időpont lenne jobb?",
      suggestionText: "Ha a felajánlott időpontok közül egyik sem megfelelő, küldj egy másik javaslatot. Megnézzük, hogy megoldható-e, és visszajelzünk neked.",
      suggestionOpenButton: "Nem jó az időpont?",
      suggestionModalTitle: "Küldj másik átvételi javaslatot",
      suggestionModalText: "Adj meg egy másik negyedórás pontosságú időpontot. Ha nincs kiválasztott felszerelési sáv, ezzel is véglegesítheted a foglalást.",
      suggestionTimeLabel: "Javasolt átvételi idő",
      suggestionHourLabel: "Óra",
      suggestionMinuteLabel: "Perc",
      suggestionCancel: "Mégse",
      suggestionSubmit: "Javaslat elküldése",
      suggestionButton: "Időjavaslat küldése",
      suggestionSending: "Küldés...",
      suggestionValidationError: "Válassz dátumot, majd adj meg egy javasolt időpontot.",
      suggestionSuccess: "A javaslatot elmentettük ehhez a foglaláshoz.",
      suggestionError: "Most nem sikerült elmenteni az időpontjavaslatot.",
      suggestionTimeFormatError: "Csak negyedórás időpont adható meg, például 20:00, 20:15, 20:30 vagy 20:45.",
      rangeCalendar: {
        label: "Bérlési időszak",
        placeholder: "Válassz kezdő- és végdátumot",
        fromLabel: "Mettől",
        toLabel: "Meddig",
        fromPlaceholder: "Mettől",
        toPlaceholder: "Meddig",
        pickEndDate: "válaszd ki a leadás napját",
        selectedRange: "Kijelölt időszak",
        previousMonth: "<",
        nextMonth: ">",
        weekdays: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
        helper: "A narancssárga sáv a kijelölt bérlést jelzi."
      }
    },
    boxes: {
      "Thule Force 3 L": {
        shortDescription: "A Thule Force 3 L modell tágas, 450 literes kialakítása lehetővé teszi, hogy egy nagyobb család hosszab utazás esetén is mindent kényelmesen bepakolhasson.",
        recommendedFor: "",
        features: [
          "5–7 pár síléc",
          "3–5 snowboard",
          "3 nagyobb bőrönd + táskák",
          "75 kg-ig terhelhető",
          "Mindkét oldalról nyitható",
          "Belső méret: 187 × 73 × 37 cm"
        ]
      },
      "Thule Pulse 2 M": {
        shortDescription: "A Thule Pulse 2 M egyszerű és megbízható, 400 literes tetőbox mindennapi használathoz, rövidebb kiruccanásokhoz és hétvégi csomagokhoz.",
        recommendedFor: "",
        depositAmount: 45000,
        features: [
          "3–5 pár síléc",
          "3–5 snowboard",
          "3 közepes bőrönd + kisebb táskák",
          "75 kg-ig terhelhető",
          "Mindkét oldalról nyitható",
          "Belső méret: 167 × 69 × 39 cm"
        ]
      },
      "Thule Force XT S": {
        shortDescription: "A Thule Force XT S kompakt kialakítása lehetővé teszi, hogy 3 kisebb bőröndöt kényelmesen elhelyezz benne, miközben kisebb autókon is arányos marad.",
        recommendedFor: "",
        features: [
          "3 kisebb bőrönd",
          "75 kg-ig terhelhető",
          "Mindkét oldalról nyitható",
          "Belső méret: 127 × 78 × 34 cm"
        ]
      },
      "Thule Touring M": {
        shortDescription: "A Thule Touring M 400 literes kialakítása rövidebb autókon is praktikus plusz csomagteret biztosít, így családi utazásokhoz, bőröndökhöz és sportfelszereléshez is jó választás.",
        recommendedFor: "",
        features: [
          "4–6 pár síléc",
          "3–4 snowboard",
          "3 közepes bőrönd + kisebb táskák",
          "50 kg-ig terhelhető",
          "Mindkét oldalról nyitható",
          "Belső méret: 170 × 77 × 39 cm"
        ]
      },
      "Thule WingBar Evo": {
        shortDescription: "A Thule WingBar Evo szett mindent tartalmaz, hogy a tetőbox vagy a kerékpártartó akár a több ezer kilométeres utakon is stabilak maradjanak.",
        recommendedFor: "Ha nincs saját tetősín rendszered",
        capacityLabel: "1 pár"
      }
    },
    skiSnowboardProducts: {
      "Thule Force 3 L": {
        shortDescription: "A tágas Thule Force 3 L síutakhoz, snowboardos kiruccanásokhoz és téli csomagok szállításához is praktikus választás.",
        recommendedFor: "Sífelszereléshez és téli csomagokhoz"
      },
      "Thule Xtender 739 síléctartó": {
        shortDescription: "A Thule Xtender 739 kihúzható, tetőcsomagtartóra szerelhető sí- és snowboardtartó, amely megkönnyíti a felszerelés fel- és lepakolását.",
        recommendedFor: "",
        capacityLabel: "6 pár síléc",
        features: [
          "Tetőcsomagtartóra szerelhető",
          "Legfeljebb 4 snowboard",
          "Legfeljebb 6 pár síléc",
          "Zárható"
        ]
      },
      "Hólánc": {
        shortDescription: "Kizárólag König hóláncot biztosítunk, mindig a foglaláskor megadott autótípushoz és kerékmérethez megfelelő kivitelben.",
        recommendedFor: "",
        capacityLabel: "1 pár",
        features: [
          "König hólánc",
          "Autótípushoz és kerékmérethez kiválasztva",
          "A megfelelő méretet a foglalás alapján szerezzük be"
        ]
      }
    },
    bikeRacks: {
      "Thule ClipOn": {
        shortDescription: "Az autó hátfalára szerelhető kerékpártartó, tetőcsomagtartó és vonóhorog nélkül.",
        recommendedFor: "Hátfalra szerelhető kerékpártartóhoz",
        capacityLabel: "3 kerékpár"
      },
      "Thule ProRide": {
        shortDescription: "A Thule ProRide tetőcsomagtartóra szerelhető kerékpártartó egy legfeljebb 20 kg-os kerékpárhoz. Önállóan pozicionáló vázfogója és gyors kerékpántjai egyszerű, stabil rögzítést biztosítanak.",
        recommendedFor: "",
        capacityLabel: "1 kerékpár",
        features: [
          "Tetőcsomagtartóra szerelhető",
          "Autótól függően 3–4 tartó is elfér; több is bérelhető",
          "20 kg teherbírás tartónként",
          "A tartó a tetőcsomagtartóhoz zárható",
          "A kerékpár a tartóhoz zárható"
        ]
      },
      "Thule VeloCompact": {
        shortDescription: "A Thule VeloCompact stabil, vonóhorogra szerelhető kerékpártartó 3 kerékpárhoz, bővítővel pedig egy negyedikhez. Beépített világítása és zárható rögzítései hosszabb utakon is kényelmes szállítást biztosítanak.",
        recommendedFor: "",
        capacityLabel: "3 + 1 kerékpár",
        features: [
          "3 + 1 kerékpár",
          "7 és 13 pólusú csatlakozó",
          "Vonóhorogra szerelhető",
          "Helyzetjelző, féklámpa és irányjelző",
          "A kerékpárok a tartóhoz zárhatók",
          "A tartó a vonóhoroghoz zárható",
          "60 kg maximális összterhelés",
          "Egy kerékpár legfeljebb 25 kg"
        ]
      }
    }
  }
};

translations.en = JSON.parse(JSON.stringify(translations.hu));
Object.assign(translations.en, {
  languageLabel: "Language",
  nav: {
    products: "Roof boxes",
    roofBoxes: "Roof boxes",
    roofRacks: "Roof racks",
    skiSnowboard: "Ski and Snowboard",
    guide: "Useful info",
    prices: "Prices",
    faq: "FAQ",
    contact: "Contact",
    admin: "Admin",
    openMenu: "Open menu",
    closeMenu: "Close menu"
  },
  footer: {
    privacy: "Privacy notice",
    terms: "Terms"
  },
  brand: "Pakold Fel",
  hero: {
    eyebrow: "Pakold Fel",
    titleLines: ["Roof box rental", "Bike rack rental", "Snow chain rental"],
    text: "",
    imageAlt: "Car with a roof box in a mountain setting"
  },
  products: {
    kicker: "Available models",
    title: "",
    scrollPrevious: "Scroll left",
    scrollNext: "Scroll right"
  },
  accessories: {
    kicker: "Roof rack rental",
    title: ""
  },
  skiSnowboard: {
    kicker: "Ski and Snowboard",
    title: ""
  },
  guide: {
    kicker: "Why choose us",
    title: "Everything important in one place",
    subtitle: "We gathered the key information so you can quickly understand the rental process and the related conditions.",
    steps: [
      {
        title: "1. Free installation",
        text: "We handle the installation, so there is no separate fitting fee."
      },
      {
        title: "2. Compatible roof rails for every car type",
        text: "If your car does not already have a system, we help you choose the right roof rail solution and provide a compatible setup."
      },
      {
        title: "3. Transparent payment and deposit",
        text: "You can see the daily rental fee, the product deposit and the available payment methods before booking."
      }
    ]
  },
  prices: {
    kicker: "Prices",
    title: "",
    wingBarKitNote: "On the first rental, HUF 10,000 is charged if a car-specific fitting kit is needed for installation.",
    columns: {
      product: "Product",
      volume: "Volume",
      dailyPrice: "Daily price",
      deposit: "Deposit",
      recommendation: "Recommended for"
    }
  },
  faq: {
    kicker: "FAQ",
    title: "",
    items: [
      {
        title: "How much does installation cost?",
        text: "We handle the installation ourselves, so there is no separate fitting fee."
      },
      {
        title: "Do you have a compatible roof rail for every car?",
        text: "Yes, we help you find the right solution and provide a roof rail that fits the car type."
      },
      {
        title: "How can I see the payment and deposit in advance?",
        text: "Alongside the daily rental fee, you can see the product deposit and the available payment methods during booking."
      },
      {
        title: "How is home delivery charged?",
        text: "Home delivery is always calculated from a base fee and the distance in kilometres. You will see the exact amount during booking after entering the address."
      },
      {
        title: "When should I book the roof box?",
        text: "It is best to book about two weeks before the planned departure date, especially for summer weekends and holiday periods."
      },
      {
        title: "What should I bring for handover?",
        text: "You only need the car and the required details. We will help with the setup and walk you through the usage."
      }
    ]
  },
  landing: {
    eyebrow: "Roof box rental in Budapest",
    title: "Book a roof box in Budapest with ease",
    lead:
      "If you are looking for roof box rental in Budapest, this page gives you a quick overview of prices, deposit, pickup and booking options.",
    cards: [
      {
        title: "Clear pricing",
        text: "You can see the daily price and deposit for each selected roof box or roof rack right away."
      },
      {
        title: "Budapest pickup",
        text: "Pickup happens at a pre-arranged time at our Budapest location."
      },
      {
        title: "We help you choose",
        text: "If you are unsure which box or roof rack fits your car, we will help you choose the right one."
      }
    ],
    ctaBoxes: "View roof boxes",
    ctaContact: "Contact",
    backHome: "Back to home",
    note:
      "Booking is straightforward, with prices and deposits visible up front so you can compare the options easily."
  },
  contact: {
    kicker: "Contact",
    title: "",
    phone: "Phone",
    phoneValue: "+36 30 833 9512",
    email: "Email",
    emailValue: "info@pakoldfel.hu",
    pickup: "Pickup",
    pickupValue: "1095 Budapest, Máriássy street 6A (garage door P6)"
  },
  admin: {
    kicker: "Booking admin",
    title: "Incoming and active bookings",
    subtitle: "Here you can see when customers are coming for fitting, how long the rental lasts, and whether they requested WingBar as well.",
    backButton: "Back to website",
    loading: "Loading bookings...",
    loadError: "The booking list is not available right now.",
    yes: "Yes",
    no: "No",
    currency: "Ft",
    rentalNumberValue: "Booking #{count}",
    guestRentalValue: "Guest",
    columns: {
      product: "Product",
      customer: "Customer",
      rentalNumber: "Customer number",
      contact: "Contact",
      vehicle: "Vehicle",
      roofMount: "Mount type",
      pickup: "Pickup",
      from: "Start date",
      to: "End date",
      wingBar: "WingBar",
      delivery: "Home delivery",
      paymentMethod: "Payment",
      deposit: "Deposit",
      pickupSuggestion: "Suggestion",
      deliveryAddress: "Address",
      total: "Total"
    },
    pricing: {
      kicker: "Pricing",
      title: "Update prices for roof boxes and roof racks",
      text: "Here you can update the daily rental fee and deposit for each product.",
      railLabel: "Roof rack",
      boxLabel: "Roof box",
      bikeLabel: "Bike rack",
      winterLabel: "Ski and Snowboard",
      dailyPrice: "Daily price (Ft)",
      deposit: "Deposit (Ft)",
      submit: "Save price",
      saving: "Saving...",
      success: "Prices saved.",
      error: "Could not save the prices right now."
    },
    dashboard: {
      activeRentals: "Active rentals",
      upcomingPickups: "Today's and tomorrow's pickups",
      wingBarRentals: "Bookings with WingBar",
      pickupSuggestions: "Bookings with time suggestions"
    },
    filters: {
      all: "All",
      today: "Today's pickups",
      delivery: "Home delivery",
      wingBar: "WingBar"
    },
    schedule: {
      kicker: "Pickup slots",
      title: "Customize daily fitting times",
      text: "Set a separate time window for a given day if you want to change the usual 18:00-21:00 slot.",
      date: "Date",
      start: "Start",
      end: "End",
      hour: "Hour",
      minute: "Minute",
      interval: "Interval (minutes)",
      submit: "Save slot",
      saving: "Saving...",
      success: "Custom slot saved.",
      error: "Could not save the custom slot right now.",
      empty: "There are no overridden time slots yet."
    },
    delivery: {
      kicker: "Home delivery",
      title: "Configure home delivery fees",
      text: "Here you can set the starting address, the base fee, and the per-kilometre charge.",
      enabled: "Enable home delivery",
      originAddress: "Starting address",
      freeDeliveryRadius: "Free delivery radius (km)",
      originsHelp: "Delivery is free within or on any free delivery circle, measured in a straight line. Set 0 km to disable the free delivery zone. Outside these circles, pricing uses the nearest starting point.",
      addOrigin: "Add starting point",
      removeOrigin: "Remove point",
      originAddressPlaceholder: "For example: Budapest, XI. district, Etele út 10.",
      baseFee: "Base fee (Ft)",
      pricePerKilometer: "Price per kilometre (Ft / km)",
      submit: "Save home delivery settings",
      saving: "Saving...",
      success: "Home delivery settings saved.",
      error: "Could not save the home delivery settings right now."
    },
    sections: {
      activeKicker: "Next tasks",
      activeTitle: "Upcoming and pending rentals",
      activeEmpty: "There are currently no upcoming or active rentals.",
      previousKicker: "Archive",
      previousTitle: "Previous rentals",
      previousEmpty: "There are no completed rentals in the archive yet."
    },
    emptyTitle: "No bookings recorded yet",
    emptyText: "As soon as someone books a roof box or roof rack, it will appear here in the list.",
    auth: {
      kicker: "Admin login",
      title: "Sign in to the admin area",
      text: "Enter the configured admin username and password.",
      checking: "Checking admin session...",
      loadError: "The admin area is not available right now.",
      sessionExpired: "The session has expired, please sign in again.",
      username: "Username",
      usernamePlaceholder: "e.g. admin",
      password: "Password",
      passwordPlaceholder: "Enter the password",
      submit: "Sign in",
      submitting: "Signing in...",
      loginError: "Admin sign-in failed.",
      logout: "Sign out",
      loggedInAs: "Signed in as: {username}"
    }
  },
  boxCard: {
    available: "Available now",
    unavailable: "Currently unavailable",
    details: "Details and booking",
    liters: "litres",
    roofRailFact: "Roof rail set",
    skiRackCapacity: "6 skis",
    bikeMountLocations: {
      "bike-towbar": "Towbar-mounted",
      "bike-roof": "Roof-mounted",
      "bike-rear": "Boot-mounted"
    },
    stockLabel: "in stock",
    remainingLabel: "available",
    pricePerDay: "Ft / day",
    depositLabel: "Deposit",
    currency: "Ft"
  },
  booking: {
    kicker: "Booking",
    title: "Booking details",
    formTitle: "Booking",
    productFeaturesTitle: "Key features",
    contactSectionTitle: "Contact",
    rentalSectionTitle: "Rental period",
    extraSectionTitle: "Extras and notes",
    summaryTitle: "Booking summary",
    summaryProduct: "Selected product",
    summaryDates: "Rental period",
    summaryDatesEmpty: "Not selected yet",
    summaryVehicle: "Vehicle",
    summaryVehicleEmpty: "Not provided yet",
    summaryRoofMount: "Mount type",
    summaryRoofMountEmpty: "Not selected yet",
    summaryPickup: "Pickup slot",
    summaryPickupEmpty: "Not selected yet",
    summaryPickupSuggested: "To be arranged separately",
    summaryWingBar: "Roof rail accessory",
    summaryDeposit: "Deposit",
    summaryPaymentMethod: "Payment method",
    summaryPaymentMethodEmpty: "Not selected yet",
    summaryDelivery: "Home delivery",
    summaryDeliveryAddress: "Pickup and return address",
    summaryDeliveryAddressEmpty: "Not provided yet",
    summaryDeliveryFee: "Home delivery fee",
    summaryDeliveryFeeEmpty: "Enter the address to calculate it",
    summaryIncluded: "Yes, please",
    summaryNotIncluded: "Not needed",
    summarySuggestion: "Custom time suggestion",
    summaryComment: "Note",
    summaryCommentEmpty: "Not provided",
    summaryDays: "Number of days",
    guestMode: "Guest",
    loginMode: "Sign in",
    loginModeHelper: "Sign in or create an account and the system will automatically fill in your details.",
    customerName: "Full name",
    customerEmail: "Email address",
    customerPhone: "Phone number",
    customerNamePlaceholder: "For example: Peter Kiss",
    customerEmailPlaceholder: "example@email.com",
    customerPhonePlaceholder: "+36 30 833 9512",
    bookingCommentLabel: "Note",
    bookingCommentPlaceholder: "For example: a special request, important information, or anything worth discussing.",
    includeWingBarLabel: "With roof rack",
    homeDeliveryLabel: "I would like home delivery to the same address for both installation and removal.",
    deliveryAddressLabel: "Pickup and return address",
    deliveryAddressPlaceholder: "For example: Budapest, XI. district, Bartok Bela ut 22, 3/12",
    deliveryAddressError: "Enter a detailed address for home delivery.",
    deliveryAddressTooShort: "The address is still too short to calculate the fee.",
    deliveryCalculationError: "Could not calculate the home delivery fee right now.",
    deliveryCalculationMissing: "The home delivery fee has not been calculated yet.",
    deliveryCalculating: "Calculating home delivery fee...",
    deliveryMapTitle: "Check address on map",
    deliveryMapShow: "Check address on map",
    deliveryMapHide: "Hide map",
    deliveryMapOpen: "Open in larger map",
    paymentSectionTitle: "Payment",
    paymentMethodError: "Choose a payment method.",
    paymentOptions: [
      {
        value: "cash-on-pickup",
        label: "Pay in cash in person"
      },
      {
        value: "transfer-on-pickup",
        label: "Bank transfer in person"
      }
    ],
    roofMountTypes: [
      {
        value: "raised-rails",
        label: "Raised rails"
      },
      {
        value: "naked-roof",
        label: "Normal roof without fixed mounting points"
      },
      {
        value: "flush-rails",
        label: "Flush rails"
      },
      {
        value: "fixed-points",
        label: "Fixed points"
      }
    ],
    roofMountTypeLabel: "Mount type",
    roofMountTypeError: "Choose a mount type.",
    vehicleBrand: "Vehicle make",
    vehicleModel: "Vehicle model",
    vehicleYear: "Model year",
    vehicleBrandPlaceholder: "For example: Volkswagen",
    vehicleModelPlaceholder: "For example: Passat",
    vehicleYearPlaceholder: "For example: 2020",
    snowChainSectionTitle: "Snow chain details",
    snowChainVehicleDetails: "Exact vehicle type",
    snowChainVehicleDetailsPlaceholder: "For example: Volkswagen Passat, 2020",
    snowChainVehicleDetailsError: "Enter the exact vehicle type.",
    snowChainWheelSize: "Wheel size",
    snowChainWheelSizePlaceholder: "For example: 225/50 R17",
    snowChainWheelSizeError: "Enter the wheel size.",
    vehicleBrandError: "Enter a real vehicle make.",
    vehicleModelError: "Enter a real vehicle model.",
    vehicleYearError: "Enter a valid model year.",
    vehicleFieldsError: "Fill in the vehicle details as well.",
    pickupNoteError: "",
    missingDates: "Choose the start and end date of the rental.",
    missingPickupSlot: "Choose an available fitting slot as well.",
    loginBeforeBookingError: "You still need to sign in before you can book with an account.",
    bookingError: "Could not complete the booking.",
    bookingSuccess: "The booking was recorded successfully.",
    successTitle: "Booking successful",
    successBannerText: "We have recorded your booking. We will contact you soon with the exact pickup and handover time.",
    consentSectionTitle: "Acceptance",
    termsConsentLabel: "I accept the",
    privacyConsentLabel: "I accept the",
    termsLinkLabel: "Terms and Conditions",
    privacyLinkLabel: "Privacy Notice",
    consentError: "To complete the booking, please accept the Terms and Conditions and the Privacy Notice.",
    submit: "Complete booking",
    submitting: "Processing...",
    totalPrice: "Total",
    microHelperTitle: "Quick booking help",
    microHelperText: "You can go through the process as a guest, but with an account your next booking will be faster.",
    helperSteps: [
      {
        title: "1. Choose the period",
        text: "Select in a single calendar when you need the product from and until."
      },
      {
        title: "2. Check availability",
        text: "Darker days are already booked, and we highlight your selected rental period with a separate color."
      },
      {
        title: "3. Confirm pickup",
        text: "Choose a free fitting slot or send your own suggested time to the admin."
      }
    ],
    suggestionTitle: "Would another time work better?",
    suggestionText: "If none of the offered time slots work for you, send another suggestion. We will check whether it can be arranged and get back to you.",
    suggestionOpenButton: "Time does not work?",
    suggestionModalTitle: "Send another pickup suggestion",
    suggestionModalText: "Provide another time with 15-minute precision. If no fitting slot is selected, you can still finalize the booking with this.",
    suggestionTimeLabel: "Suggested pickup time",
    suggestionHourLabel: "Hour",
    suggestionMinuteLabel: "Minute",
    suggestionCancel: "Cancel",
    suggestionSubmit: "Send suggestion",
    suggestionButton: "Send time suggestion",
    suggestionSending: "Sending...",
    suggestionValidationError: "Choose a date, then enter a suggested time.",
    suggestionSuccess: "We saved the suggestion for this booking.",
    suggestionError: "Could not save the time suggestion right now.",
    suggestionTimeFormatError: "Only quarter-hour times are allowed, for example 20:00, 20:15, 20:30 or 20:45.",
    rangeCalendar: {
      label: "Rental period",
      placeholder: "Choose start and end dates",
      fromLabel: "From",
      toLabel: "To",
      fromPlaceholder: "From",
      toPlaceholder: "To",
      pickEndDate: "choose the return date",
      selectedRange: "Selected period",
      previousMonth: "<",
      nextMonth: ">",
      weekdays: ["M", "T", "W", "T", "F", "S", "S"],
      helper: "The orange bar marks the selected rental period."
    }
  },
  boxes: {
    "Thule Force 3 L": {
      shortDescription: "Genuine Thule Force 3 L model, a spacious and reliable roof box for family trips, longer getaways, and generous luggage space.",
      recommendedFor: "",
      features: [
        "5–7 pairs of skis",
        "3–5 snowboards",
        "3 larger suitcases + bags",
        "Load capacity up to 75 kg",
        "Opens from both sides",
        "Internal dimensions: 187 × 73 × 37 cm"
      ]
    },
    "Thule Pulse 2 M": {
      shortDescription: "The Thule Pulse 2 M is a simple and reliable 400-litre roof box for everyday use, short getaways, and weekend luggage.",
      recommendedFor: "",
      depositAmount: 45000,
      features: [
        "3–5 pairs of skis",
        "3–5 snowboards",
        "3 medium suitcases + smaller bags",
        "Load capacity up to 75 kg",
        "Opens from both sides",
        "Internal dimensions: 167 × 69 × 39 cm"
      ]
    },
    "Thule Force XT S": {
      shortDescription: "The compact Thule Force XT S comfortably holds 3 smaller suitcases while remaining well proportioned on smaller cars.",
      recommendedFor: "",
      features: [
        "3 smaller suitcases",
        "Load capacity up to 75 kg",
        "Opens from both sides",
        "Internal dimensions: 127 × 78 × 34 cm"
      ]
    },
    "Thule Touring M": {
      shortDescription: "The 400-litre Thule Touring M adds practical storage even to shorter cars, making it a good choice for family trips, suitcases, and sports equipment.",
      recommendedFor: "",
      features: [
        "4–6 pairs of skis",
        "3–4 snowboards",
        "3 medium suitcases + smaller bags",
        "Load capacity up to 50 kg",
        "Opens from both sides",
        "Internal dimensions: 170 × 77 × 39 cm"
      ]
    },
    "Thule WingBar Evo": {
      shortDescription: "Genuine Thule WingBar Evo system with correctly sized aerodynamic crossbars selected for the car.",
      recommendedFor: "If you do not have your own roof rail system",
      capacityLabel: "1 pair"
    }
  },
  skiSnowboardProducts: {
    "Thule Force 3 L": {
      shortDescription: "Available as a ski box too: a spacious Thule Force 3 L roof box for ski trips, snowboard trips and winter travel.",
      recommendedFor: "For ski gear and winter luggage"
    },
    "Thule Xtender 739 síléctartó": {
      shortDescription: "The Thule Xtender 739 is a pull-out roof-mounted ski and snowboard rack that makes loading and unloading winter equipment easier.",
      recommendedFor: "",
      capacityLabel: "6 pairs of skis",
      features: [
        "Mounts on a roof rack",
        "Up to 4 snowboards",
        "Up to 6 pairs of skis",
        "Lockable"
      ]
    },
    "Hólánc": {
      shortDescription: "We provide König snow chains selected specifically for the vehicle type and wheel size entered during booking.",
      recommendedFor: "",
      capacityLabel: "1 pair",
      features: [
        "König snow chains",
        "Matched to the vehicle type and wheel size",
        "The correct size is sourced from the booking details"
      ]
    }
  },
  bikeRacks: {
    "Thule ClipOn": {
      shortDescription: "A rear-mounted bike rack for carrying bicycles without roof bars or a towbar.",
      recommendedFor: "For rear-mounted bicycle transport",
      capacityLabel: "3 bikes"
    },
    "Thule ProRide": {
      shortDescription: "The Thule ProRide is a roof-mounted carrier for one bicycle weighing up to 20 kg. Its self-positioning frame holder and quick wheel straps make loading simple and secure.",
      recommendedFor: "",
      capacityLabel: "1 bike",
      features: [
        "Mounts on a roof rack",
        "Depending on the car, 3–4 carriers may fit; multiple units are available",
        "20 kg capacity per carrier",
        "Carrier locks to the roof rack",
        "Bicycle locks to the carrier"
      ]
    },
    "Thule VeloCompact": {
      shortDescription: "The Thule VeloCompact is a stable towbar-mounted carrier for 3 bicycles, expandable for a fourth. Integrated lights and lockable mounting points make it practical for longer journeys.",
      recommendedFor: "",
      capacityLabel: "3 + 1 bikes",
      features: [
        "3 + 1 bicycles",
        "7-pin and 13-pin connector",
        "Towbar-mounted",
        "Position lights, brake lights, and indicators",
        "Bicycles lock to the carrier",
        "Carrier locks to the towbar",
        "60 kg maximum total load",
        "Maximum 25 kg per bicycle"
      ]
    }
  }
});

const fallbackBoxes = [
  {
    id: "11111111-1111-1111-1111-111111111111",
    name: "Thule Force 3 L",
    category: "roof-box",
    imageUrl: "/pictures/thule-force-3-l.png",
    shortDescription: "A Thule Force 3 L tágas, megbízható tetőbox családi utakhoz, hétvégi kiruccanásokhoz és bőséges csomagtérhez.",
    recommendedFor: "Családi nyaraláshoz, hosszabb utakhoz és nagyobb csomaghoz",
    volume: 450,
    price: 2400,
    depositAmount: 50000,
    totalQuantity: 1,
    isAvailable: true
  },
  {
    id: "22222222-2222-2222-2222-222222222222",
    name: "Thule Pulse 2 M",
    category: "roof-box",
    imageUrl: "/pictures/thule-pulse-2-m.png",
    shortDescription: "A Thule Pulse 2 M egyszerű és megbízható, 400 literes tetőbox mindennapi használathoz, rövidebb kiruccanásokhoz és hétvégi csomagokhoz.",
    recommendedFor: "",
    volume: 400,
    price: 2000,
    depositAmount: 45000,
    totalQuantity: 1,
    isAvailable: true
  },
  {
    id: "44444444-4444-4444-4444-444444444448",
    name: "Thule Force XT S",
    category: "roof-box",
    imageUrl: "/pictures/thule-force-xt-s.png",
    shortDescription: "A Thule Force XT S kompakt kialakítása lehetővé teszi, hogy 3 kisebb bőröndöt kényelmesen elhelyezz benne, miközben kisebb autókon is arányos marad.",
    recommendedFor: "",
    volume: 300,
    price: 1600,
    depositAmount: 40000,
    totalQuantity: 1,
    isAvailable: true
  },
  {
    id: "44444444-4444-4444-4444-444444444449",
    name: "Thule Touring M",
    category: "roof-box",
    imageUrl: "/pictures/thule-touring-m.png",
    shortDescription: "A Thule Touring M 400 literes kialakítása rövidebb autókon is praktikus plusz csomagteret biztosít, így családi utazásokhoz, bőröndökhöz és sportfelszereléshez is jó választás.",
    recommendedFor: "",
    volume: 400,
    price: 1800,
    depositAmount: 40000,
    totalQuantity: 1,
    isAvailable: true
  },
  {
    id: "33333333-3333-3333-3333-333333333333",
    name: "Thule WingBar Evo",
    category: "roof-rail",
    imageUrl: "/pictures/thule-wingbar-evo.png",
    shortDescription: "Valódi Thule WingBar Evo rendszer, az autóhoz választott megfelelő méretű aerodinamikus keresztléc-párral és T-track kompatibilitással.",
    recommendedFor: "Ha nincs saját tetősín rendszered",
    volume: 0,
    capacityLabel: "1 pár",
    price: 1000,
    depositAmount: 20000,
    totalQuantity: 4,
    isAvailable: true
  },
  {
    id: "44444444-4444-4444-4444-44444444444a",
    name: "Thule ProRide",
    category: "bike-roof",
    imageUrl: "/pictures/thule-proride-591.png",
    shortDescription: "A Thule ProRide tetőcsomagtartóra szerelhető kerékpártartó egy legfeljebb 20 kg-os kerékpárhoz. Önállóan pozicionáló vázfogója és gyors kerékpántjai egyszerű, stabil rögzítést biztosítanak.",
    recommendedFor: "",
    capacityLabel: "1 kerékpár",
    volume: 0,
    price: 1000,
    depositAmount: 20000,
    totalQuantity: 1,
    isAvailable: true
  },
  {
    id: "44444444-4444-4444-4444-44444444444b",
    name: "Thule VeloCompact",
    category: "bike-towbar",
    imageUrl: "/pictures/thule-velocompact-926.png",
    shortDescription: "A Thule VeloCompact stabil, vonóhorogra szerelhető kerékpártartó 3 kerékpárhoz, bővítővel pedig egy negyedikhez. Beépített világítása és zárható rögzítései hosszabb utakon is kényelmes szállítást biztosítanak.",
    recommendedFor: "",
    capacityLabel: "3 + 1 kerékpár",
    volume: 0,
    price: 2400,
    depositAmount: 50000,
    totalQuantity: 1,
    isAvailable: true
  },
  {
    id: "44444444-4444-4444-4444-44444444444c",
    name: "Thule ClipOn",
    category: "bike-rear",
    imageUrl: "/pictures/thule-clipon.png",
    shortDescription: "Az autó hátfalára szerelhető kerékpártartó, tetőcsomagtartó és vonóhorog nélkül.",
    recommendedFor: "Hátfalra szerelhető kerékpártartóhoz",
    capacityLabel: "3 kerékpár",
    volume: 0,
    price: 1600,
    depositAmount: 20000,
    totalQuantity: 1,
    isAvailable: true
  },
  {
    id: "55555555-5555-5555-5555-555555555555",
    name: "Thule Xtender 739 síléctartó",
    category: "ski-rack",
    imageUrl: "/pictures/thule-xtender-739.png",
    shortDescription: "A Thule Xtender 739 kihúzható, tetőcsomagtartóra szerelhető sí- és snowboardtartó, amely megkönnyíti a felszerelés fel- és lepakolását.",
    recommendedFor: "",
    capacityLabel: "6 pár síléc",
    volume: 0,
    price: 1400,
    depositAmount: 20000,
    totalQuantity: 1,
    isAvailable: true
  },
  {
    id: "66666666-6666-6666-6666-666666666666",
    name: "Hólánc",
    category: "snow-chain",
    imageUrl: "/pictures/snow-chain.png",
    shortDescription: "Kizárólag König hóláncot biztosítunk, mindig a foglaláskor megadott autótípushoz és kerékmérethez megfelelő kivitelben.",
    recommendedFor: "",
    capacityLabel: "1 pár",
    volume: 0,
    price: 1200,
    depositAmount: 10000,
    totalQuantity: 1,
    isAvailable: true
  },
];

const productImageGalleries = {
  "Thule Force 3 L": [
    "/pictures/thule-force-3-l.png",
    "/pictures/optimized/thule-force-3-l-gallery-4.jpg",
    "/pictures/optimized/thule-force-3-l-gallery-5.jpg",
    "/pictures/optimized/thule-force-3-l-gallery-6.jpg",
    "/pictures/optimized/thule-force-3-l-gallery-7.jpg",
    "/pictures/optimized/thule-force-3-l-gallery-8.jpg",
    "/pictures/optimized/thule-force-3-l-gallery-9.jpg"
  ],
  "Thule Pulse 2 M": [
    "/pictures/thule-pulse-2-m.png",
    "/pictures/optimized/thule-pulse-2-m-gallery-1.jpg",
    "/pictures/optimized/thule-pulse-2-m-gallery-2.jpg"
  ],
  "Thule Touring M": [
    "/pictures/thule-touring-m.png",
    "/pictures/optimized/thule-touring-m-gallery-1.jpg",
    "/pictures/optimized/thule-touring-m-gallery-2.jpg"
  ],
  "Thule VeloCompact": [
    "/pictures/thule-velocompact-926.png",
    "/pictures/optimized/thule-velocompact-926-gallery-4.jpg",
    "/pictures/optimized/thule-velocompact-926-gallery-5.jpg",
    "/pictures/optimized/thule-velocompact-926-gallery-6.jpg",
    "/pictures/optimized/thule-velocompact-926-gallery-7.jpg",
    "/pictures/optimized/thule-velocompact-926-gallery-8.jpg"
  ],
  "Thule ProRide": [
    "/pictures/thule-proride-591.png",
    "/pictures/optimized/thule-proride-591-gallery-2.jpg",
    "/pictures/optimized/thule-proride-591-gallery-3.jpg",
    "/pictures/optimized/thule-proride-591-gallery-4.jpg"
  ],
  "Thule Force XT S": [
    "/pictures/thule-force-xt-s.png",
    "/pictures/optimized/thule-force-xt-s-gallery-6.jpg",
    "/pictures/optimized/thule-force-xt-s-gallery-7.jpg",
    "/pictures/optimized/thule-force-xt-s-gallery-8.jpg",
    "/pictures/optimized/thule-force-xt-s-gallery-9.jpg",
    "/pictures/optimized/thule-force-xt-s-gallery-10.jpg",
    "/pictures/optimized/thule-force-xt-s-gallery-11.jpg"
  ],
  "Thule Xtender 739 síléctartó": [
    "/pictures/thule-xtender-739.png",
    "/pictures/optimized/thule-xtender-739-gallery-1.png",
    "/pictures/optimized/thule-xtender-739-gallery-2.png",
    "/pictures/optimized/thule-xtender-739-gallery-3.png"
  ],
  "Hólánc": [
    "/pictures/snow-chain.png"
  ]
};

function getProductCatalogName(box) {
  if (box.name === "Thule ProRide 591") return "Thule ProRide";
  if (["Thule VeloCompact 926", "Thule VeloCompact 926 / 927"].includes(box.name)) return "Thule VeloCompact";
  if (box.name === "Thule Force 3 S") return "Thule Force XT S";
  return box.name;
}

function getDefaultProductRouteSection(box) {
  if (["bike-roof", "bike-towbar", "bike-rear"].includes(box.category)) {
    return "kerekpartartok";
  }

  if (["ski-rack", "snow-chain"].includes(box.category)) {
    return "teli-sportok";
  }

  return "tetoboxok";
}

function getProductRoutePath(box, routeSection = getDefaultProductRouteSection(box)) {
  return createProductRoute(routeSection, createProductRouteSlug(getProductCatalogName(box)));
}

function App() {
  function normalizeBoxMedia(box) {
    const productName = getProductCatalogName(box);
    const configuredGallery = productImageGalleries[productName] ?? [];
    const imageCandidates = productName === "Thule Force XT S"
      ? [...configuredGallery, box.imageUrl]
      : [box.imageUrl, ...configuredGallery];
    const imageGallery = Array.from(new Set(imageCandidates.filter(Boolean)));

    return {
      ...box,
      imageUrl: imageGallery[0] ?? box.imageUrl,
      imageGallery
    };
  }

  function getLocalizedProductContent(box) {
    const translationGroup = ["bike-roof", "bike-towbar", "bike-rear"].includes(box.category)
      ? t.bikeRacks
      : box.category === "ski-rack" || box.category === "snow-chain"
        ? t.skiSnowboardProducts
        : t.boxes;
    const translatedProduct = translationGroup?.[getProductCatalogName(box)];

    return {
      name: getProductCatalogName(box),
      shortDescription: translatedProduct?.shortDescription ?? box.shortDescription,
      recommendedFor: translatedProduct?.recommendedFor ?? box.recommendedFor,
      capacityLabel: translatedProduct?.capacityLabel ?? box.capacityLabel,
      depositAmount: translatedProduct?.depositAmount ?? box.depositAmount,
      detailDescription: translatedProduct?.detailDescription ?? box.detailDescription,
      features: translatedProduct?.features ?? box.features
    };
  }

  const [boxes, setBoxes] = useState([]);
  const [language, setLanguage] = useState("hu");
  const t = translations[language] ?? translations.hu;
  const [currentHash, setCurrentHash] = useState(getHash());
// Temporarily disabled: customer accounts.
//   const [currentAccount, setCurrentAccount] = useState(() => readStoredAccount());
//   const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
//   const [accountModalMode, setAccountModalMode] = useState("login");
//   const [isAccountSubmitting, setIsAccountSubmitting] = useState(false);
//   const [accountErrorMessage, setAccountErrorMessage] = useState("");
//   const [accountSuccessMessage, setAccountSuccessMessage] = useState("");
//   const [accountFieldErrors, setAccountFieldErrors] = useState({});
//   const [accountCelebration, setAccountCelebration] = useState(null);
//   const [requiresProfileCompletion, setRequiresProfileCompletion] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
// Temporarily disabled: customer accounts.
//   const [isGoogleLoginEnabled, setIsGoogleLoginEnabled] = useState(false);
//   const [accountForm, setAccountForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//     resetCode: ""
//   });
  const productCarouselRef = useRef(null);
  // const processedExternalLoginTicketRef = useRef(null);
  const [canScrollProductsLeft, setCanScrollProductsLeft] = useState(false);
  const [canScrollProductsRight, setCanScrollProductsRight] = useState(false);

  useEffect(() => {
    let isCancelled = false;

    getAllBoxes()
      .then(data => {
        if (isCancelled) {
          return;
        }

        if (Array.isArray(data) && data.length > 0) {
          setBoxes(data);
          return;
        }

        setBoxes(fallbackBoxes);
      })
      .catch(() => {
        if (!isCancelled) {
          setBoxes(fallbackBoxes);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, []);

// Temporarily disabled: customer accounts.
//   useEffect(() => {
//     let isCancelled = false;
//
//     getGoogleLoginStatus()
//       .then(result => {
//         if (!isCancelled) {
//           setIsGoogleLoginEnabled(Boolean(result?.enabled));
//         }
//       })
//       .catch(() => {
//         if (!isCancelled) {
//           setIsGoogleLoginEnabled(false);
//         }
//       });
//
//     return () => {
//       isCancelled = true;
//     };
//   }, []);
//
//   useEffect(() => {
//     persistStoredAccount(currentAccount);
//   }, [currentAccount]);
//
  useEffect(() => {
    function handleRouteChange() {
      setCurrentHash(getHash());
      setIsMobileMenuOpen(false);
    }

    window.addEventListener("popstate", handleRouteChange);
    return () => window.removeEventListener("popstate", handleRouteChange);
  }, []);

  useEffect(() => {
    const selectedBoxId = getSelectedBoxId(currentHash);

    if (
      selectedBoxId ||
      isAdminHash(currentHash) ||
      currentHash === "/" ||
      currentHash.startsWith(resetPasswordRoutePrefix) ||
      currentHash.startsWith("/oauth-complete")
    ) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [currentHash, t.account.completeProfilePrompt]);

// Temporarily disabled: customer accounts.
//   useEffect(() => {
//     const resetParams = getPasswordResetParams(currentHash);
//
//     if (!resetParams) {
//       return;
//     }
//
//     setAccountModalMode("reset-confirm");
//     setAccountErrorMessage("");
//     setAccountSuccessMessage("");
//     setAccountFieldErrors({});
//     setAccountForm({
//       name: "",
//       email: resetParams.email,
//       phone: "",
//       password: "",
//       confirmPassword: "",
//       resetCode: resetParams.token
//     });
//     setIsAccountModalOpen(true);
//   }, [currentHash, t.account.completeProfilePrompt]);
//
//   useEffect(() => {
//     const externalLoginTicket = getExternalLoginTicket(currentHash);
//
//     if (!externalLoginTicket) {
//       processedExternalLoginTicketRef.current = null;
//       return;
//     }
//
//     if (processedExternalLoginTicketRef.current === externalLoginTicket) {
//       return;
//     }
//
//     processedExternalLoginTicketRef.current = externalLoginTicket;
//
//     async function finalizeExternalLogin() {
//       const returnPath = consumeExternalLoginReturnHash();
//
//       try {
//         const account = await completeExternalLogin(externalLoginTicket);
//
//         persistStoredAccount(account);
//         setCurrentAccount(account);
//         const isProfileComplete = Boolean(account.phone?.trim()) && (account.name?.trim()?.length ?? 0) >= 2;
//
//         setAccountErrorMessage("");
//         setAccountFieldErrors({});
//
//         if (isProfileComplete) {
//           setRequiresProfileCompletion(false);
//           setIsAccountModalOpen(false);
//           setAccountSuccessMessage("");
//         } else {
//           setRequiresProfileCompletion(true);
//           setAccountModalMode("edit");
//           setAccountSuccessMessage(t.account.completeProfilePrompt);
//           setAccountForm({
//             name: account.name ?? "",
//             email: account.email ?? "",
//             phone: account.phone ?? "",
//             password: "",
//             confirmPassword: "",
//             resetCode: ""
//           });
//           setIsAccountModalOpen(true);
//         }
//
//         window.history.replaceState({}, "", returnPath);
//         setCurrentHash(getHash());
//       } catch (error) {
//         setAccountModalMode("login");
//         setAccountErrorMessage(error.message || "Google login failed.");
//         setAccountSuccessMessage("");
//         setIsAccountModalOpen(true);
//         window.history.replaceState({}, "", returnPath);
//         setCurrentHash(getHash());
//       }
//     }
//
//     finalizeExternalLogin();
//   }, [currentHash, t.account.completeProfilePrompt]);
//
//   useEffect(() => {
//     if (!accountCelebration) {
//       return undefined;
//     }
//
//     const timeoutId = window.setTimeout(() => {
//       setAccountCelebration(null);
//     }, 2600);
//
//     return () => window.clearTimeout(timeoutId);
//   }, [accountCelebration]);
//
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 860) {
        setIsMobileMenuOpen(false);
      }
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

// Temporarily disabled: customer accounts.
//   function openAccountModal(mode = "login") {
//     setAccountModalMode(mode);
//     setAccountErrorMessage("");
//     setAccountSuccessMessage("");
//     setAccountFieldErrors({});
//     setAccountForm({
//       name: mode === "edit" && currentAccount ? currentAccount.name : "",
//       email: mode === "edit" && currentAccount ? currentAccount.email : "",
//       phone: mode === "edit" && currentAccount ? currentAccount.phone : "",
//       password: "",
//       confirmPassword: "",
//       resetCode: ""
//     });
//     setIsAccountModalOpen(true);
//   }
//
//   function updateAccountModalMode(mode) {
//     setAccountModalMode(mode);
//     setAccountErrorMessage("");
//     setAccountSuccessMessage("");
//     setAccountFieldErrors({});
//     setAccountForm(current => ({
//       ...current,
//       name: mode === "edit" && currentAccount ? currentAccount.name : mode === "register" ? current.name : "",
//       email: mode === "edit" && currentAccount ? currentAccount.email : current.email,
//       phone: mode === "edit" && currentAccount ? currentAccount.phone : mode === "register" ? current.phone : "",
//       password: "",
//       confirmPassword: "",
//       resetCode: ""
//     }));
//   }
//
//   function handleAccountFormChange(field, value) {
//     setAccountForm(current => ({ ...current, [field]: value }));
//   }
//
//   function clearAccountFieldError(field) {
//     setAccountFieldErrors(current => ({ ...current, [field]: "" }));
//   }
//
//   function closeAccountModal() {
//     if (currentHash.startsWith(resetPasswordRoutePrefix)) {
//       window.history.replaceState({}, "", "/");
//       setCurrentHash(getHash());
//     }
//
//     setIsAccountModalOpen(false);
//     setAccountErrorMessage("");
//     setAccountSuccessMessage("");
//     setAccountFieldErrors({});
//     setRequiresProfileCompletion(false);
//   }
//
//   function validateAccountForm(mode) {
//     const nextErrors = {};
//     const trimmedName = accountForm.name.trim();
//     const trimmedEmail = accountForm.email.trim();
//     const trimmedPhone = accountForm.phone.trim();
//     const trimmedPassword = accountForm.password.trim();
//     const trimmedConfirmPassword = accountForm.confirmPassword.trim();
//     const trimmedResetCode = accountForm.resetCode.trim();
//
//     if (mode === "reset-request") {
//       if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(trimmedEmail)) {
//         nextErrors.email = t.account.emailError;
//       }
//
//       setAccountFieldErrors(nextErrors);
//       return nextErrors;
//     }
//
//     if (mode === "reset-confirm") {
//       if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(trimmedEmail)) {
//         nextErrors.email = t.account.emailError;
//       }
//
//       if (!trimmedResetCode) {
//         nextErrors.resetCode = t.account.resetCodeError;
//       }
//
//       if (trimmedPassword.length < 6) {
//         nextErrors.password = t.account.passwordError;
//       }
//
//       if (!trimmedConfirmPassword) {
//         nextErrors.confirmPassword = t.account.confirmPasswordError;
//       } else if (trimmedPassword !== trimmedConfirmPassword) {
//         nextErrors.confirmPassword = t.account.passwordMismatchError;
//       }
//
//       setAccountFieldErrors(nextErrors);
//       return nextErrors;
//     }
//
//     if ((mode === "register" || mode === "edit") && trimmedName.length < 2) {
//       nextErrors.name = t.account.nameError;
//     }
//
//     if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(trimmedEmail)) {
//       nextErrors.email = t.account.emailError;
//     }
//
//     if ((mode === "register" || mode === "edit") && !/^\+?[0-9\s\-()]{8,20}$/.test(trimmedPhone)) {
//       nextErrors.phone = t.account.phoneError;
//     }
//
//     if ((mode === "login" || mode === "register") && trimmedPassword.length < 6) {
//       nextErrors.password = t.account.passwordError;
//     }
//
//     if (mode === "register") {
//       if (!trimmedConfirmPassword) {
//         nextErrors.confirmPassword = t.account.confirmPasswordError;
//       } else if (trimmedPassword !== trimmedConfirmPassword) {
//         nextErrors.confirmPassword = t.account.passwordMismatchError;
//       }
//     }
//
//     setAccountFieldErrors(nextErrors);
//     return nextErrors;
//   }
//
//   async function handleAccountSubmit(event) {
//     event.preventDefault();
//
//     const validationErrors = validateAccountForm(accountModalMode);
//
//     if (Object.keys(validationErrors).length > 0) {
//       setAccountErrorMessage(
//         accountModalMode === "reset-request"
//           ? t.account.resetRequestValidationError
//           : accountModalMode === "reset-confirm"
//             ? t.account.resetConfirmValidationError
//             : t.account.validationError
//       );
//       setAccountSuccessMessage("");
//       return;
//     }
//
//     try {
//       setIsAccountSubmitting(true);
//       setAccountErrorMessage("");
//       setAccountSuccessMessage("");
//
//       if (accountModalMode === "reset-request") {
//         await requestPasswordReset({
//           email: accountForm.email.trim()
//         });
//
//         setAccountSuccessMessage(t.account.resetRequestSuccess);
//         setAccountForm(current => ({ ...current, password: "", confirmPassword: "" }));
//       } else if (accountModalMode === "reset-confirm") {
//         await confirmPasswordReset({
//           email: accountForm.email.trim(),
//           resetCode: accountForm.resetCode.trim(),
//           newPassword: accountForm.password.trim()
//         });
//
//         setAccountSuccessMessage(t.account.resetConfirmSuccess);
//         window.setTimeout(() => {
//           window.history.replaceState({}, "", "/");
//           setCurrentHash(getHash());
//           openAccountModal("login");
//           setAccountSuccessMessage(t.account.resetConfirmSuccess);
//         }, 500);
//       } else {
//         const result = accountModalMode === "login"
//           ? await loginAccount({
//               email: accountForm.email.trim(),
//               password: accountForm.password.trim()
//             })
//           : accountModalMode === "register"
//             ? await registerAccount({
//                 name: accountForm.name.trim(),
//                 email: accountForm.email.trim(),
//                 phone: accountForm.phone.trim(),
//                 password: accountForm.password.trim()
//               })
//             : await updateAccount(currentAccount.id, {
//                 name: accountForm.name.trim(),
//                 email: accountForm.email.trim(),
//                 phone: accountForm.phone.trim()
//               });
//
//         setCurrentAccount(result);
//         setAccountSuccessMessage(
//           accountModalMode === "login"
//             ? t.account.loginSuccess
//             : accountModalMode === "register"
//               ? t.account.registerSuccess
//               : t.account.updateSuccess
//         );
//
//         if (accountModalMode === "register") {
//           setAccountCelebration({
//             title: t.account.registerCelebration,
//             text: t.account.registerCelebrationText
//           });
//         }
//
//         if (accountModalMode === "edit" && requiresProfileCompletion) {
//           setRequiresProfileCompletion(false);
//           setAccountCelebration({
//             title: t.account.registerCelebration,
//             text: t.account.profileCompleteSuccess
//           });
//           window.setTimeout(() => {
//             closeAccountModal();
//           }, 700);
//           return;
//         }
//
//         if (accountModalMode !== "edit") {
//           window.setTimeout(() => {
//             closeAccountModal();
//           }, 500);
//         }
//       }
//     } catch (error) {
//       setAccountErrorMessage(error.message || t.account.validationError);
//       setAccountSuccessMessage("");
//     } finally {
//       setIsAccountSubmitting(false);
//     }
//   }
//
//   function handleLogout() {
//     setCurrentAccount(null);
//     closeAccountModal();
//   }
//
  const localizedBoxes = useMemo(
    () =>
      boxes.map(box => ({
        ...normalizeBoxMedia(box),
        ...getLocalizedProductContent(box)
      })),
    [boxes, t]
  );

  const roofBoxes = localizedBoxes.filter(box => box.category === "roof-box");
  const accessories = ["bike-towbar", "bike-roof", "bike-rear"].flatMap(category =>
    localizedBoxes.filter(box => box.category === category)
  );
  const winterAccessories = ["snow-chain", "ski-rack"].flatMap(category =>
    localizedBoxes.filter(box => box.category === category)
  );
  const skiBoxBase = localizedBoxes.find(box => getProductCatalogName(box) === "Thule Force 3 L");
  const skiBoxTranslation = t.skiSnowboardProducts?.["Thule Force 3 L"];
  const skiSnowboardProducts = [
    ...winterAccessories,
    skiBoxBase && skiBoxTranslation
      ? { ...skiBoxBase, ...skiBoxTranslation }
      : skiBoxBase
  ].filter(Boolean);
  const wingBarBase = localizedBoxes.find(box => box.name === "Thule WingBar Evo") ?? null;
  const [wingBarDetails, setWingBarDetails] = useState(null);
  const [skiCarouselElement, setSkiCarouselElement] = useState(null);
  const [canScrollSkiLeft, setCanScrollSkiLeft] = useState(false);
  const [canScrollSkiRight, setCanScrollSkiRight] = useState(false);
  const accessoryCarouselRef = useRef(null);
  const [canScrollAccessoriesLeft, setCanScrollAccessoriesLeft] = useState(false);
  const [canScrollAccessoriesRight, setCanScrollAccessoriesRight] = useState(false);
  const pricingBoxes = useMemo(
    () => {
      const productOrder = [
        "Thule Force XT S",
        "Thule Touring M",
        "Thule Pulse 2 M",
        "Thule Force 3 L",
        "Thule ProRide",
        "Thule ClipOn",
        "Thule VeloCompact",
        "Thule Xtender 739 síléctartó",
        "Hólánc",
        "Thule WingBar Evo"
      ];
      const orderByName = new Map(productOrder.map((name, index) => [name, index]));
      return [
        ...roofBoxes,
        ...accessories,
        ...winterAccessories,
        ...(wingBarBase ? [wingBarBase] : [])
      ].sort((first, second) =>
        (orderByName.get(getProductCatalogName(first)) ?? productOrder.length) -
        (orderByName.get(getProductCatalogName(second)) ?? productOrder.length)
      );
    },
    [roofBoxes, accessories, winterAccessories, wingBarBase]
  );
  const selectedBoxId = getSelectedBoxId(currentHash);
  const selectedBoxBase = localizedBoxes.find(box =>
    box.id === selectedBoxId ||
    createBoxRouteSlug(box.name) === selectedBoxId ||
    createBoxRouteSlug(getProductCatalogName(box)) === selectedBoxId ||
    createProductRouteSlug(box.name) === selectedBoxId ||
    createProductRouteSlug(getProductCatalogName(box)) === selectedBoxId
  ) ?? null;
  const [selectedBoxDetails, setSelectedBoxDetails] = useState(null);
  const [selectedBoxDetailsLoaded, setSelectedBoxDetailsLoaded] = useState(false);
  const isAdminRoute = isAdminHash(currentHash);
  const isTermsRoute = currentHash === termsRoute;
  const isPrivacyNoticeRoute = currentHash === privacyNoticeRoute;
  const isRentalAgreementRoute = currentHash === rentalAgreementRoute;
  const homeSectionId = getHomeSectionId(currentHash);
  const selectedProductRouteSection = getProductRouteSection(currentHash);

  useEffect(() => {
    let isCancelled = false;

    if (!selectedBoxBase) {
      setSelectedBoxDetails(null);
      setSelectedBoxDetailsLoaded(true);
      return undefined;
    }

    setSelectedBoxDetails(null);
    setSelectedBoxDetailsLoaded(false);

    getBoxById(selectedBoxBase.id)
      .then(box => {
        if (!isCancelled) {
          setSelectedBoxDetails(box);
          setSelectedBoxDetailsLoaded(true);
        }
      })
      .catch(() => {
        if (!isCancelled) {
          setSelectedBoxDetails(selectedBoxBase);
          setSelectedBoxDetailsLoaded(true);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [selectedBoxBase, currentHash]);

  const selectedBox = useMemo(
    () =>
      selectedBoxDetails
        ? {
            ...normalizeBoxMedia(selectedBoxDetails),
            ...getLocalizedProductContent(selectedBoxDetails)
          }
        : selectedBoxBase,
    [selectedBoxBase, selectedBoxDetails, t]
  );
  const selectedBoxRouteLoading = Boolean(selectedBoxId) && !selectedBoxDetailsLoaded;

  useEffect(() => {
    if (!selectedBox || selectedProductRouteSection !== "legacy") {
      return;
    }

    window.history.replaceState({}, "", getProductRoutePath(selectedBox));
    setCurrentHash(getHash());
  }, [selectedBox, selectedProductRouteSection]);

  useEffect(() => {
    const pageMeta = (() => {
      if (selectedBox) {
        return {
          title: `${selectedBox.name} | Pakold Fel`,
          description: `${selectedBox.name} bérlés a Pakold Fel oldalán. Ár, kaució, elérhetőség és foglalás egy helyen.`,
          canonical: `${window.location.origin}${getProductRoutePath(selectedBox)}`,
          image: `${window.location.origin}${selectedBox.imageUrl}`
        };
      }

      if (isTermsRoute) {
        return {
          title: `ÁSZF | Pakold Fel`,
          description: "Pakold Fel általános szerződési feltételek.",
          canonical: `${window.location.origin}${termsRoute}`,
          image: `${window.location.origin}/pictures/pakold-fel-logo.png`
        };
      }

      if (isPrivacyNoticeRoute) {
        return {
          title: `Adatkezelési tájékoztató | Pakold Fel`,
          description: "Pakold Fel adatkezelési tájékoztatója.",
          canonical: `${window.location.origin}${privacyNoticeRoute}`,
          image: `${window.location.origin}/pictures/pakold-fel-logo.png`
        };
      }

      if (isRentalAgreementRoute) {
        return {
          title: `Bérleti szerződés | Pakold Fel`,
          description: "Pakold Fel bérleti szerződése.",
          canonical: `${window.location.origin}${rentalAgreementRoute}`,
          image: `${window.location.origin}/pictures/pakold-fel-logo.png`
        };
      }

      if (homeSectionId) {
        const sectionMeta = {
          "roof-boxes": {
            title: "Tetőboxok | Pakold Fel",
            description: "Bérelhető tetőboxok, árak, kauciók és foglalási lehetőségek a Pakold Fel oldalán."
          },
          "bike-racks": {
            title: "Kerékpártartók | Pakold Fel",
            description: "Bérelhető tetőre és vonóhorogra szerelhető kerékpártartók a Pakold Fel oldalán."
          },
          "ski-snowboard": {
            title: "Téli sportok | Pakold Fel",
            description: "Síbox, síléctartó és König hólánc bérlés a Pakold Fel oldalán."
          },
          prices: {
            title: "Árak | Pakold Fel",
            description: "A Pakold Fel tetőbox-, kerékpártartó- és téli felszerelés-bérlési árai."
          },
          faq: {
            title: "Gyakori kérdések | Pakold Fel",
            description: "Gyakori kérdések és válaszok a Pakold Fel bérlési szolgáltatásairól."
          },
          contact: {
            title: "Kapcsolat | Pakold Fel",
            description: "Kapcsolatfelvétel a Pakold Fel tetőbox- és felszerelés-bérlési szolgáltatásához."
          }
        }[homeSectionId];

        return {
          ...sectionMeta,
          canonical: `${window.location.origin}${getHomeSectionRoute(homeSectionId)}`,
          image: `${window.location.origin}/pictures/header_image.avif`
        };
      }

      return {
        title: `Pakold Fel | Tetőbox bérlés Budapesten`,
        description: "Tetőbox bérlés Budapesten egyszerű foglalással, átlátható árakkal és gyors visszaigazolással.",
        canonical: window.location.origin,
        image: `${window.location.origin}/pictures/header_image.avif`
      };
    })();

    document.title = pageMeta.title;
    document.documentElement.lang = language === "en" ? "en" : "hu";

    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
      descriptionMeta.setAttribute("content", pageMeta.description);
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute("href", pageMeta.canonical);
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute("content", pageMeta.title);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute("content", pageMeta.description);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute("content", pageMeta.canonical);
    }

    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      ogImage.setAttribute("content", pageMeta.image);
    }

    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute("content", pageMeta.title);
    }

    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute("content", pageMeta.description);
    }

    const twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (twitterImage) {
      twitterImage.setAttribute("content", pageMeta.image);
    }
  }, [
    currentHash,
    homeSectionId,
    isPrivacyNoticeRoute,
    isRentalAgreementRoute,
    isTermsRoute,
    selectedBox,
    language
  ]);

  useEffect(() => {
    let isCancelled = false;

    if (!wingBarBase) {
      setWingBarDetails(null);
      return undefined;
    }

    setWingBarDetails(null);

    getBoxById(wingBarBase.id)
      .then(box => {
        if (!isCancelled) {
          setWingBarDetails(box);
        }
      })
      .catch(() => {
        if (!isCancelled) {
          setWingBarDetails(wingBarBase);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [wingBarBase, currentHash]);

  const wingBarProduct = useMemo(
    () =>
      wingBarDetails
        ? {
            ...wingBarDetails,
            ...getLocalizedProductContent(wingBarDetails)
          }
        : wingBarBase,
    [wingBarBase, wingBarDetails, t]
  );

  useEffect(() => {
    if (selectedBox || isAdminRoute || isTermsRoute || isPrivacyNoticeRoute || isRentalAgreementRoute) {
      return undefined;
    }

    const revealElements = Array.from(document.querySelectorAll(".reveal-on-scroll"));

    if (revealElements.length === 0) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px 350px 0px"
      }
    );

    revealElements.forEach(element => {
      observer.observe(element);
    });

    return () => observer.disconnect();
  }, [currentHash, isAdminRoute, isTermsRoute, isPrivacyNoticeRoute, isRentalAgreementRoute, selectedBox, language]);

  useEffect(() => {
    if (!homeSectionId || selectedBox || isAdminRoute || isTermsRoute || isPrivacyNoticeRoute || isRentalAgreementRoute) {
      return undefined;
    }

    const animationFrame = window.requestAnimationFrame(() => {
      scrollToHomeSection(homeSectionId, "auto");
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, [homeSectionId, isAdminRoute, isPrivacyNoticeRoute, isRentalAgreementRoute, isTermsRoute, selectedBox]);

  function openBoxDetails(box, routeSection) {
    window.history.pushState({}, "", getProductRoutePath(box, routeSection));
    setCurrentHash(getHash());
  }

  function scrollToHomeSection(targetId, behavior = "smooth") {
    const targetElement = document.getElementById(targetId);

    if (!targetElement) {
      return;
    }

    const topbarHeight = document.querySelector(".topbar")?.getBoundingClientRect().height ?? 0;
    const targetTop = targetElement.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: Math.max(targetTop - topbarHeight - 16, 0),
      behavior
    });
  }

  function navigateHomeSection(sectionId) {
    setIsMobileMenuOpen(false);
    const targetId = sectionId.replace(/^#/, "");
    const targetRoute = getHomeSectionRoute(targetId);

    if (currentHash !== targetRoute) {
      window.history.pushState({}, "", targetRoute);
      setCurrentHash(getHash());
      window.dispatchEvent(new PopStateEvent("popstate"));
      return;
    }

    scrollToHomeSection(targetId);
  }

  function navigateToRoute(path, replace = false) {
    const nextPath = toRoutePath(path);
    window.history[replace ? "replaceState" : "pushState"]({}, "", nextPath);
    setCurrentHash(getHash());
    window.dispatchEvent(new PopStateEvent("popstate"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  function getNearestProductIndex(carouselElement) {
    const children = Array.from(carouselElement.children);

    if (children.length === 0) {
      return 0;
    }

    let nearestIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;

    children.forEach((child, index) => {
      if (!(child instanceof HTMLElement)) {
        return;
      }

      const distance = Math.abs(child.offsetLeft - carouselElement.firstElementChild.offsetLeft - carouselElement.scrollLeft);

      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  function scrollToProductIndex(carouselElement, targetIndex) {
    const targetChild = carouselElement.children[targetIndex];

    if (!(targetChild instanceof HTMLElement)) {
      return;
    }

    const previewInset = targetIndex > 0 ? Math.min(carouselElement.clientWidth * 0.12, 90) : 0;

    carouselElement.scrollTo({
      left: Math.max(targetChild.offsetLeft - carouselElement.firstElementChild.offsetLeft - previewInset, 0),
      behavior: "smooth"
    });
  }

  function scrollProducts(direction) {
    const carouselElement = productCarouselRef.current;

    if (!carouselElement) {
      return;
    }

    const currentIndex = getNearestProductIndex(carouselElement);
    const directionOffset = direction === "next" ? 1 : -1;
    const nextIndex = Math.max(0, Math.min(carouselElement.children.length - 1, currentIndex + directionOffset));

    scrollToProductIndex(carouselElement, nextIndex);
  }

  function handleProductCarouselWheel(event) {
    const carouselElement = productCarouselRef.current;

    if (!carouselElement) {
      return;
    }

    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
      return;
    }

    event.preventDefault();
    carouselElement.scrollLeft += event.deltaY;
  }

  function getNearestAccessoryIndex(carouselElement) {
    const children = Array.from(carouselElement.children);

    if (children.length === 0) {
      return 0;
    }

    let nearestIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;

    children.forEach((child, index) => {
      if (!(child instanceof HTMLElement)) {
        return;
      }

      const distance = Math.abs(child.offsetLeft - carouselElement.firstElementChild.offsetLeft - carouselElement.scrollLeft);

      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  function scrollToAccessoryIndex(carouselElement, targetIndex) {
    const targetChild = carouselElement.children[targetIndex];

    if (!(targetChild instanceof HTMLElement)) {
      return;
    }

    const previewInset = targetIndex > 0 ? Math.min(carouselElement.clientWidth * 0.12, 90) : 0;

    carouselElement.scrollTo({
      left: Math.max(targetChild.offsetLeft - carouselElement.firstElementChild.offsetLeft - previewInset, 0),
      behavior: "smooth"
    });
  }

  function scrollAccessories(direction) {
    const carouselElement = accessoryCarouselRef.current;

    if (!carouselElement) {
      return;
    }

    const currentIndex = getNearestAccessoryIndex(carouselElement);
    const directionOffset = direction === "next" ? 1 : -1;
    const nextIndex = Math.max(0, Math.min(carouselElement.children.length - 1, currentIndex + directionOffset));

    scrollToAccessoryIndex(carouselElement, nextIndex);
  }

  function handleAccessoryCarouselWheel(event) {
    const carouselElement = event.currentTarget;

    if (!carouselElement) {
      return;
    }

    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
      return;
    }

    event.preventDefault();
    carouselElement.scrollLeft += event.deltaY;
  }

  useEffect(() => {
    const carouselElement = productCarouselRef.current;

    if (!carouselElement || roofBoxes.length === 0) {
      setCanScrollProductsLeft(false);
      setCanScrollProductsRight(false);
      return undefined;
    }

    function updateProductCarouselState() {
      const maxScrollLeft = Math.max(0, carouselElement.scrollWidth - carouselElement.clientWidth);
      setCanScrollProductsLeft(carouselElement.scrollLeft > 4);
      setCanScrollProductsRight(carouselElement.scrollLeft < maxScrollLeft - 4);
    }

    updateProductCarouselState();
    carouselElement.addEventListener("scroll", updateProductCarouselState, { passive: true });
    window.addEventListener("resize", updateProductCarouselState);
    return () => {
      carouselElement.removeEventListener("scroll", updateProductCarouselState);
      window.removeEventListener("resize", updateProductCarouselState);
    };
  }, [roofBoxes, currentHash]);

  function scrollSki(direction) {
    const carouselElement = skiCarouselElement;
    if (!carouselElement) return;
    const currentIndex = getNearestProductIndex(carouselElement);
    const nextIndex = Math.max(0, Math.min(carouselElement.children.length - 1,
      currentIndex + (direction === "next" ? 1 : -1)));
    scrollToProductIndex(carouselElement, nextIndex);
  }

  useEffect(() => {
    const carouselElement = skiCarouselElement;
    if (!carouselElement) return undefined;
    function updateSkiCarouselState() {
      const maxScrollLeft = Math.max(0, carouselElement.scrollWidth - carouselElement.clientWidth);
      setCanScrollSkiLeft(carouselElement.scrollLeft > 4);
      setCanScrollSkiRight(carouselElement.scrollLeft < maxScrollLeft - 4);
    }
    updateSkiCarouselState();
    carouselElement.addEventListener("scroll", updateSkiCarouselState, { passive: true });
    window.addEventListener("resize", updateSkiCarouselState);
    return () => {
      carouselElement.removeEventListener("scroll", updateSkiCarouselState);
      window.removeEventListener("resize", updateSkiCarouselState);
    };
  }, [skiCarouselElement, skiSnowboardProducts.length, currentHash]);

  useEffect(() => {
    const carouselElement = accessoryCarouselRef.current;

    if (!carouselElement || accessories.length === 0) {
      setCanScrollAccessoriesLeft(false);
      setCanScrollAccessoriesRight(false);
      return undefined;
    }

    function updateAccessoryCarouselState() {
      const maxScrollLeft = Math.max(0, carouselElement.scrollWidth - carouselElement.clientWidth);

      setCanScrollAccessoriesLeft(carouselElement.scrollLeft > 4);
      setCanScrollAccessoriesRight(carouselElement.scrollLeft < maxScrollLeft - 4);
    }

    updateAccessoryCarouselState();
    carouselElement.addEventListener("scroll", updateAccessoryCarouselState, { passive: true });
    window.addEventListener("resize", updateAccessoryCarouselState);

    return () => {
      carouselElement.removeEventListener("scroll", updateAccessoryCarouselState);
      window.removeEventListener("resize", updateAccessoryCarouselState);
    };
  }, [accessories, currentHash]);

  return (
    <div className="page-shell">
      <main className="page-content">
        <header className="topbar">
          <div className="topbar-brand-row">
            <button type="button" className="brand-mark brand-button" onClick={() => navigateToRoute("/")}>
              <span className="sr-only">{t.brand}</span>
              <img
                className="brand-logo"
                src="/pictures/pakold-fel-logo-header.png"
                alt={t.brand}
                width="420"
                height="267"
                decoding="async"
                fetchPriority="high"
              />
            </button>

          <button
            type="button"
            className={`mobile-menu-toggle ${isMobileMenuOpen ? "active" : ""}`}
              aria-label={isMobileMenuOpen ? t.nav.closeMenu : t.nav.openMenu}
              aria-expanded={isMobileMenuOpen}
              onClick={() => setIsMobileMenuOpen(current => !current)}
            >
              <span />
              <span />
              <span />
            </button>
          </div>

          <nav className={`topbar-nav ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            <button type="button" onClick={() => navigateHomeSection("#roof-boxes")}>{t.nav.roofBoxes ?? t.nav.products}</button>
            <button type="button" onClick={() => navigateHomeSection("#bike-racks")}>{t.nav.roofRacks ?? t.accessories.kicker}</button>
            <button type="button" onClick={() => navigateHomeSection("#ski-snowboard")}>{t.nav.skiSnowboard ?? t.skiSnowboard.kicker}</button>
            <button type="button" onClick={() => navigateHomeSection("#prices")}>{t.nav.prices}</button>
            <button type="button" onClick={() => navigateHomeSection("#faq")}>{t.nav.faq}</button>
            <button type="button" onClick={() => navigateHomeSection("#contact")}>{t.nav.contact}</button>
          </nav>

          <div className={`topbar-actions ${isMobileMenuOpen ? "mobile-open" : ""}`}>
{/* Temporarily disabled: customer accounts.
            <button
              type="button"
              className="account-chip"
              onClick={() => openAccountModal(currentAccount ? "edit" : "login")}
            >
              <span className="account-chip-copy">
                {currentAccount ? `${t.account.loggedInPrefix} ${currentAccount.name}` : t.account.guestLabel}
              </span>
            </button>

*/}
            <div className="language-switcher" aria-label={t.languageLabel}>
              <button
                type="button"
                className={language === "hu" ? "active" : ""}
                onClick={() => setLanguage("hu")}
              >
                HU
              </button>
              <button
                type="button"
                className={language === "en" ? "active" : ""}
                onClick={() => setLanguage("en")}
              >
                EN
              </button>
            </div>
          </div>
        </header>

        <Suspense fallback={null}>
          {isAdminRoute ? (
            <AdminPage labels={t.admin} onBack={() => navigateToRoute("/")} />
          ) : isTermsRoute ? (
            <TermsPage language={language} onBack={() => navigateToRoute("/")} />
          ) : isPrivacyNoticeRoute ? (
            <PrivacyNoticePage language={language} onBack={() => navigateToRoute("/")} />
          ) : isRentalAgreementRoute ? (
            <RentalAgreementPage language={language} onBack={() => navigateToRoute("/")} />
          ) : selectedBoxRouteLoading ? (
            <div className="route-loading-panel">
              <p>{language === "hu" ? "A kiválasztott termék betöltése folyamatban..." : "Loading the selected product..."}</p>
            </div>
          ) : selectedBox ? (
            <BoxBookingPage
              box={selectedBox}
              labels={t.booking}
              boxCardLabels={t.boxCard}
              wingBarProduct={wingBarProduct}
              onBack={() => navigateToRoute("/")}
              accountSession={null /* currentAccount */}
              onOpenAccountModal={undefined /* openAccountModal */}
              termsRoute={termsRoute}
              privacyNoticeRoute={privacyNoticeRoute}
              onOpenTerms={() => navigateToRoute(termsRoute)}
              onOpenPrivacyNotice={() => navigateToRoute(privacyNoticeRoute)}
            />
          ) : (
            <HomePage
              labels={t}
              roofBoxes={roofBoxes}
              accessories={accessories}
              skiSnowboardProducts={skiSnowboardProducts}
              pricingBoxes={pricingBoxes}
              canScrollProductsLeft={canScrollProductsLeft}
              canScrollProductsRight={canScrollProductsRight}
              productCarouselRef={productCarouselRef}
              onScrollProducts={scrollProducts}
              onProductCarouselWheel={handleProductCarouselWheel}
              accessoryCarouselRef={accessoryCarouselRef}
              canScrollAccessoriesLeft={canScrollAccessoriesLeft}
              canScrollAccessoriesRight={canScrollAccessoriesRight}
              onScrollAccessories={scrollAccessories}
              onAccessoryCarouselWheel={handleAccessoryCarouselWheel}
              skiCarouselRef={setSkiCarouselElement}
              canScrollSkiLeft={canScrollSkiLeft}
              canScrollSkiRight={canScrollSkiRight}
              onScrollSki={scrollSki}
              onOpenBox={openBoxDetails}
            />
          )}
        </Suspense>
      </main>

      <footer className="site-footer">
        <div className="site-footer-inner">
          <a
            href={privacyNoticeRoute}
            onClick={event => {
              event.preventDefault();
              navigateToRoute(privacyNoticeRoute);
            }}
          >
            {t.footer.privacy}
          </a>
          <a
            href={termsRoute}
            onClick={event => {
              event.preventDefault();
              navigateToRoute(termsRoute);
            }}
          >
            {t.footer.terms}
          </a>
        </div>
      </footer>

{/* Temporarily disabled: customer accounts.
      <AccountModal
        currentHash={currentHash}
        currentAccount={currentAccount}
        isAccountModalOpen={isAccountModalOpen}
        accountModalMode={accountModalMode}
        isAccountSubmitting={isAccountSubmitting}
        accountErrorMessage={accountErrorMessage}
        accountSuccessMessage={accountSuccessMessage}
        accountFieldErrors={accountFieldErrors}
        accountForm={accountForm}
        labels={t.account}
        onClose={closeAccountModal}
        onSubmit={handleAccountSubmit}
        onModeChange={updateAccountModalMode}
        onFormChange={handleAccountFormChange}
        onFieldErrorClear={clearAccountFieldError}
        onLogout={handleLogout}
        isGoogleLoginEnabled={isGoogleLoginEnabled}
      />

      {accountCelebration && (
        <div className="success-celebration" role="status" aria-live="polite">
          <div className="success-celebration-icon" aria-hidden="true">
            <span className="success-celebration-check" />
          </div>
          <div className="success-celebration-copy">
            <strong>{accountCelebration.title}</strong>
            <span>{accountCelebration.text}</span>
          </div>
        </div>
      )}
*/}
    </div>
  );
}

export default App;



